import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import Erp from "./pages/ERP/Erp";
import Warehouse from "./pages/Warehouse/Warehouse";
import Layout from "./Layout";
import MobileSolutions from "./pages/MobileSolutions/MobileSolutions";
import TransportLogistics from "./pages/TransportLogistics/TransportLogistics";
import RetailPOS from "./pages/RetailPos/RetailPos";
import GPSServices from "./pages/GpsServices/GpsServices";
import PostageLogistics from "./pages/PostageLogistics/PostageLogistics";
import Portfolio from "./pages/Portfolio/Portfolio";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/products/erp" element={<Erp />} />
        <Route path="/products/warehouse" element={<Warehouse />} />
        <Route
          path="/products/mobile-solutions"
          element={<MobileSolutions />}
        />
        <Route
          path="/products/transport-logistics"
          element={<TransportLogistics />}
        />
        <Route path="/products/retail-pos" element={<RetailPOS />} />
        <Route path="/products/gps-services" element={<GPSServices />} />
        <Route
          path="/products/postage-logistics"
          element={<PostageLogistics />}
        />
        <Route path="/products/portfolio" element={<Portfolio />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Route>
    </Routes>
  );
}

export default App;
